export default {
  'imm5669.familyMemberTableTitle': 'Family Members',
  'imm5669.familyMemberTableFullName': 'Full name',
  'imm5669.familyMemberTableStatus': 'Status',
  'imm5669.familyMemberTableStatus.missingInformation': 'Missing Information',
  'imm5669.familyMemberTableStatus.complete': 'Complete',

  'imm5669.steps.sectionA': 'Personal details',
  'imm5669.steps.sectionB': 'Questionnaire',
  'imm5669.steps.sectionC': 'Education',
  'imm5669.steps.sectionD': 'Personal history',
  'imm5669.steps.sectionE': 'Membership and association with organizations',
  'imm5669.steps.sectionF': 'Government positions',
  'imm5669.steps.sectionG': 'Military and paramilitary service',
  'imm5669.steps.sectionH': 'Addresses',

  'imm5669.title.personal': 'Section A: Personal details',
  'imm5669.personal.fullName': 'Full name',
  'imm5669.personal.dob': 'Date of birth (YYYY/MM/DD)',
  'imm5669.personal.deceasedDate': 'Date of death, if deceased (YYYY/MM/DD)',
  'imm5669.personal.cityOfBirth': 'Town/city of birth',
  'imm5669.personal.countryOfBirth': 'Country or territory of birth',

  'imm5669.personal.father.title': 'Personal details of your father',
  'imm5669.personal.mother.title': 'Personal details of your mother',

  'imm5669.title.questionnaire': 'Section B: Questionnaire',
  'imm5669.description.questionnaire':
    'Have you or, any of your family members listed in this application, ever:',
  'imm5669.questionnaire.isConvictedInCanada':
    '1. been convicted of a crime or offence in Canada for which a pardon has not been granted under the Criminal Records Act of Canada?',
  'imm5669.questionnaire.isConvictedOutsideCanada':
    '2. been convicted of or are currently charged with, on trial for, or party to a crime or offence, or subject of any criminal proceedings in any other country or territory?',
  'imm5669.questionnaire.isClaimedRefugeeProtection':
    '3. made previous claims for refugee protection in Canada or at a Canadian visa office abroad, in any other country(ies) or territory(ies), or with the United Nations High Commissioner for Refugees (UNHCR)?',
  'imm5669.questionnaire.isRefusedRefugeeOrVisa':
    '4. been refused refugee status, an immigrant or permanent resident visa (including a Certificat de Sélection du Québec [CSQ] or application to the Provincial Nominee Program) or a visitor or temporary resident visa, for Canada or any other country or territory?',
  'imm5669.questionnaire.isOrderedToLeaveCountry':
    '5. been refused admission to, or ordered to leave, Canada or any other country or territory?',
  'imm5669.questionnaire.isWarCriminal':
    '6. been involved in an act of genocide, in a war crime or in the commission of a crime against humanity?',
  'imm5669.questionnaire.isCommittedActOfViolence':
    '7. used, planned or advocated the use of armed struggle or violence to reach political, religious or social objectives?',
  'imm5669.questionnaire.isAssociatedWithViolentGroup':
    '8. been associated with a group that used, uses, or advocated or advocates the use of armed struggle or violence to reach political, religious or social objectives?',
  'imm5669.questionnaire.isMemberOfCriminalOrg':
    '9. been a member of an organization that is or was engaged in an activity that is part of a pattern of criminal activity?',
  'imm5669.questionnaire.isDetainedOrJailed':
    '10. been detained, incarcerated or put in jail?',
  'imm5669.questionnaire.isPhysicalOrMentalDisorder':
    '11. had any serious disease or physical or mental disorder?',
  'imm5669.questionnaire.additionalDetails':
    'If your answer to any of these questions is yes, please provide details below (maximum 679 characters):',

  'imm5669.title.education': 'Section C: Education',
  'imm5669.education.overallTitle':
    'Give the number of years of school you successfully completed for each of the following levels of education:',
  'imm5669.education.elementarySchoolYears': 'Elementary/primary school',
  'imm5669.education.secondarySchoolYears': 'Secondary/high school',
  'imm5669.education.universityAndCollegeYears': 'University/college',
  'imm5669.education.otherSchoolYears':
    'Trade school or other post-secondary school',

  'imm5669.education.educationHistory.fullDetailsTitle':
    'Give full details of all the secondary and post-secondary education(including university, college and apprenticeship training) you have had.',
  'imm5669.title.formList.educationHistory': 'Education #',
  'imm5669.education.educationHistory.from': 'From (YYYY-MM)',
  'imm5669.education.educationHistory.to': 'To (YYYY-MM)',
  'imm5669.education.educationHistory.nameOfInstitution': 'Name of institution',
  'imm5669.education.educationHistory.cityAndCountry':
    'City and country/territory',
  'imm5669.education.educationHistory.typeOfDiploma':
    'Type of certificate or diploma issued',
  'imm5669.education.educationHistory.fieldOfStudy': 'Field of study',

  'imm5669.title.personalHistory': 'Section D: Personal history',
  'imm5669.description.personalHistory':
    'Provide the details of your personal history for the past 10 years, or since your 18th birthday if it was less than 10 years ago. Start with the most recent information. Under “Activity,” write your occupation or job title if you were working. If you were not working, provide information on what you were doing (for example, unemployed, studying, travelling, retired, in detention). If you were outside your country or territory of nationality, indicate your status in the country or territory you were in. Note: Please ensure that you do not leave any gaps in time',
  'imm5669.title.formList.personalHistory': 'Personal history #',
  'imm5669.personalHistory.from': 'From (YYYY-MM)',
  'imm5669.personalHistory.to': 'To (YYYY-MM)',
  'imm5669.personalHistory.activity':
    'Activity (e.g. employment - company name and position, unemployment, education)',
  'imm5669.personalHistory.cityAndCountry': 'City and country/territory',
  'imm5669.personalHistory.status':
    'Status in country or territory (e.g. work permit, citizen, student permit, visitor permit)',
  'imm5669.personalHistory.nameOfEmployerOrSchool':
    'Name of company, employer, school, facility (as applicable)',

  'imm5669.title.memberships':
    'Section E: Membership and association with organizations',
  'imm5669.description.memberships':
    'What organizations have you supported, been a member of or been associated with? Include any political, social, youth or student organization, trade unions and professional associations. Do not use abbreviations. Indicate the city and country or territory where you were a member. Write “none” in the first input field if you have not been a member of any association/organization.',
  'imm5669.title.formList.memberships': 'Membership #',
  'imm5669.memberships.from': 'From (YYYY-MM)',
  'imm5669.memberships.to': 'To (YYYY-MM)',
  'imm5669.memberships.nameOfOrganization': 'Name of organization',
  'imm5669.memberships.typeOfOrganization': 'Type of organization',
  'imm5669.memberships.activities':
    'Activities and/or positions held within organization',
  'imm5669.memberships.cityAndCountry': 'City and country/territory',

  'imm5669.title.governmentPositions': 'Section F: Government positions',
  'imm5669.description.governmentPositions':
    'List any government positions (such as civil servant, judge, police officer, employee in a security organization) you have held. Include positions you have held before or after your retirement. Do not use abbreviations. Write “none” in the first input field if you have not held any government positions.',
  'imm5669.title.formList.governmentPositions': 'Government position #',
  'imm5669.governmentPositions.from': 'From (YYYY-MM)',
  'imm5669.governmentPositions.to': 'To (YYYY-MM)',
  'imm5669.governmentPositions.cityAndCountry':
    'Country/territory and level of jurisdiction (national, regional, municipal)',
  'imm5669.governmentPositions.department': 'Department/branch',
  'imm5669.governmentPositions.activities': 'Activity and/or positions held',

  'imm5669.title.militaryPositions':
    'Section G: Military and paramilitary service',
  'imm5669.description.militaryPositions':
    'Provide complete details of military and paramilitary service for each of the countries in whose armed forces you served. Write “none” in the first input field if you have not undertaken military and/or paramilitary service. Note: Please ensure that you do not leave any gaps in time.',
  'imm5669.title.formList.militaryPositions':
    'Military and paramilitary service #',
  'imm5669.militaryPositions.country': 'Name of country or territory',
  'imm5669.militaryPositions.branchOfService':
    'Branch of service, unit numbers and names of your commanding officers',
  'imm5669.militaryPositions.from': 'From (YYYY-MM)',
  'imm5669.militaryPositions.to': 'To (YYYY-MM)',
  'imm5669.militaryPositions.rank': 'Rank(s)',
  'imm5669.militaryPositions.reasonsEndService': 'Reason for end of service',
  'imm5669.militaryPositions.combatDetails':
    'Dates and places of any active combat',

  'imm5669.title.addresses': 'Section H: Addresses',
  'imm5669.description.addresses':
    'List all addresses where you have lived in the past 10 years or since your 18th birthday if it was less than 10 years ago. Do not use P.O. box addresses.',
  'imm5669.title.formList.addresses': 'Address #',
  'imm5669.addresses.from': 'From (YYYY-MM)',
  'imm5669.addresses.to': 'To (YYYY-MM)',
  'imm5669.addresses.street': 'Street and number',
  'imm5669.addresses.city': 'City or town',
  'imm5669.addresses.provinceOrState': 'Province, state or district',
  'imm5669.addresses.country': 'Country or territory',
  'imm5669.addresses.postalCode': 'Postal code or zip code',
};
